import React, { FunctionComponent } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useMeContext } from 'modules/me';
import {
  createCustomLuxonUtils,
  DEFAULT_WEEKDAY,
  WeekDay
} from './CustomLuxonUtils';

const CustomMuiPickersUtilsProvider: FunctionComponent = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const me = useMeContext();
  const locale = me?.locale?.language?.languageCode || 'en';
  const weekDay = (me?.workWeekStartDay?.uri as WeekDay) || DEFAULT_WEEKDAY;

  return (
    <LocalizationProvider
      dateAdapter={createCustomLuxonUtils(weekDay)}
      adapterLocale={locale}
    >
      {children}
    </LocalizationProvider>
  );
};

export default CustomMuiPickersUtilsProvider;
